export const DropdownToggleIcon = ({ color = "#8D8D8D", size = 20, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M10 0.0075711L4.99545 6.00377L1.39061e-05 -2.55806e-05L10 0.0075711Z" fill={color} />
    </svg>
);
